(() => {
  const clamp = (n, min, max) => Math.min(max, Math.max(min, n));

  async function fetchCart() {
    const res = await fetch(`${window.Shopify?.routes?.root || "/"}cart.js`, {
      credentials: "same-origin",
      headers: { Accept: "application/json" },
    });
    if (!res.ok) throw new Error("cart.js fetch failed");
    return await res.json();
  }

 function moneyFormat(cents) {
  if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
    return window.Shopify.formatMoney(cents, window.Shopify.money_format || "{{amount}}");
  }
  return new Intl.NumberFormat(document.documentElement.lang || "it-IT", {
    style: "currency",
    currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "EUR",
  }).format(cents / 100);
}


  function setFill(bar) {
    const styles = getComputedStyle(bar);
    const length = parseFloat(styles.getPropertyValue("--length")) || 0;
    const max = parseFloat(styles.getPropertyValue("--max-length")) || 0;
    const fill = bar.querySelector(".free-delivery-bar__progress-fill");
    if (!fill || max <= 0) return;

    const pct = clamp((length / max) * 100, 0, 100);
    fill.style.width = `${pct}%`;
  }

  function updateBars(cart) {
    document.querySelectorAll("[data-free-delivery-bar]").forEach((bar) => {
      const styles = getComputedStyle(bar);
      const max = parseFloat(styles.getPropertyValue("--max-length")) || 0;
      if (!max || max <= 0) return;

      const total =
        cart && typeof cart.total_price === "number" ? cart.total_price : 0;

      // aggiorna length clampata (max resta quella dal liquid)
      bar.style.setProperty("--length", `${Math.min(total, max)}`);

      // opzionale: se nel liquid hai data-free-delivery-remaining sul numero
     // const remaining = Math.max(0, max - total);
     // const remainingEl = bar.querySelector("[data-free-delivery-remaining]");
      //if (remainingEl) remainingEl.textContent = moneyFormat(remaining);

      setFill(bar);
    });
  }

  async function refresh() {
    try {
      const cart = await fetchCart();
      updateBars(cart);
    } catch (e) {
      // silent
    }
  }

  // Initial
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", refresh, { once: true });
  } else {
    refresh();
  }

  // Theme events (quando aggiungi/rimuovi)
  document.addEventListener("cart:update", (e) => {
    // alcuni temi mettono il cart in e.detail.resource invece che e.detail.cart
    const cart = e?.detail?.cart || e?.detail?.resource;
    if (cart) updateBars(cart);
    else refresh();
  });
  document.addEventListener("cart:refresh", refresh);
  document.addEventListener("shopify:section:load", refresh);

  // ✅ IMPORTANTISSIMO: quando apri il drawer con item già presenti
  // patchiamo il metodo open() del custom element cart-drawer-component
  customElements.whenDefined("cart-drawer-component").then(() => {
    const proto = customElements.get("cart-drawer-component")?.prototype;
    if (!proto || proto.__freeDeliveryPatched) return;

    proto.__freeDeliveryPatched = true;
    const originalOpen = proto.open;

    if (typeof originalOpen === "function") {
      proto.open = function (...args) {
        const out = originalOpen.apply(this, args);
        // appena si apre, aggiorna la barra
        refresh();
        return out;
      };
    }
  });

  // fallback extra: se il drawer viene iniettato dopo, aggiorna appena compare
  const observer = new MutationObserver(() => {
    if (document.querySelector("[data-free-delivery-bar]")) refresh();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
